import React, { forwardRef, useImperativeHandle, useRef, useState, useContext } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { getStyleWithVendor } from '../_helpers';
import { GlobalContext } from '../context-provider';
import IconClose from '../icon/IconClose';
export var PopoverInner = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(GlobalContext),
      prefixCls = _useContext.prefixCls;

  var className = props.className,
      needShadow = props.needShadow,
      content = props.content,
      direction = props.direction,
      position = props.position,
      minWidth = props.minWidth,
      maxWidth = props.maxWidth,
      arrowWidth = props.arrowWidth,
      transformOrigin = props.transformOrigin,
      mode = props.mode,
      _props$showCloseIcon = props.showCloseIcon,
      showCloseIcon = _props$showCloseIcon === void 0 ? false : _props$showCloseIcon,
      _props$textSuffix = props.textSuffix,
      textSuffix = _props$textSuffix === void 0 ? null : _props$textSuffix,
      onClickCloseIcon = props.onClickCloseIcon,
      onClickTextSuffix = props.onClickTextSuffix;
  var domRef = useRef(null);

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  /**
   * 计算容器的样式
   */

  var getWrapperStyle = function getWrapperStyle() {
    var top = position.top,
        bottom = position.bottom,
        height = position.height,
        left = position.left,
        width = position.width;

    if (left || width || top || height || bottom) {
      if (!show) {
        setTimeout(function () {
          setShow(true);
        }, 0);
      }
    }

    var obj = {
      height: height + "px",
      left: left + "px",
      minWidth: minWidth,
      maxWidth: maxWidth
    };

    if (top) {
      obj.top = top + "px";
    } else if (bottom) {
      obj.bottom = bottom + "px";
    } // 用于执行缩放动画


    obj.transformOrigin = transformOrigin.x + " " + transformOrigin.y;
    return getStyleWithVendor(obj);
  };
  /**
   * 计算icon的样式
   */


  var getArrowStyle = function getArrowStyle() {
    var arrowLeft = position.arrowLeft;
    return {
      width: arrowWidth,
      height: arrowWidth,
      marginLeft: arrowLeft ? arrowLeft + "px" : null,
      marginRight: arrowLeft ? arrowLeft + "px" : null
    };
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: domRef,
    className: cls(prefixCls + "-popover-inner", 'popover-inner', 'all-border-box', mode + "-mode", className, {
      show: show,
      'with-shadow': needShadow,
      'with-suffix': showCloseIcon || textSuffix,
      'custom-content': typeof content !== 'string'
    }),
    style: getWrapperStyle()
  }, /*#__PURE__*/React.createElement("div", {
    className: "popover-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popover-arrow " + direction,
    style: getArrowStyle()
  }, /*#__PURE__*/React.createElement("div", {
    className: "popover-arrow-content"
  }))), /*#__PURE__*/React.createElement("div", {
    className: cls('popover-content', direction, {
      'show-close-icon': showCloseIcon
    })
  }, typeof content === 'string' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "content-text"
  }, content), showCloseIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "icon-divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-close-icon",
    onClick: onClickCloseIcon
  }, /*#__PURE__*/React.createElement(IconClose, null))), textSuffix && /*#__PURE__*/React.createElement("div", {
    className: "text-suffix",
    onClick: onClickTextSuffix
  }, textSuffix)) : content));
});